// Serving teams and the join flow.

export const DREAM_TEAMS = [
  {
    icon:"🎤",
    name:"Worship & Music",
    cat:"Music",
    desc:"Vocalists and musicians who prepare the atmosphere for the preached word."
  },
  {
    icon:"🎛️",
    name:"Production & Media",
    cat:"Media",
    desc:"Cameras, sound, slides, livestream — technology in service of the atmosphere."
  },
  {
    icon:"🚪",
    name:"Guest Experience",
    cat:"Hospitality",
    desc:"Doors, lobby, coffee — every guest seen and prepared to encounter God."
  },
  {
    icon:"🧒",
    name:"CLLXTV Kids",
    cat:"Next Generation",
    desc:"The next generation's first church memories, built with care."
  },
  {
    icon:"🙏",
    name:"Prayer",
    cat:"Intercession",
    desc:"Keeping CLLXTV on its knees — covering the room before, during, and after."
  },
  {
    icon:"📸",
    name:"Creative",
    cat:"Storytelling",
    desc:"Photo, design, and content — keeping the memory of what God is doing."
  }
];

export const JOIN_STEPS = [
  {
    t:"Raise your hand",
    d:"Fill out the quick form — takes about two minutes."
  },
  {
    t:"We reach out",
    d:"A team leader connects with you personally within a few days."
  },
  {
    t:"Get in the room",
    d:"You serve right beside your leader on day one. You're never alone."
  },
  {
    t:"Find your rhythm",
    d:"Two services starting August 2 — your gift, every Sunday, on repeat."
  }
];
